import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';

import { esnInitials } from '../../../shared/types/atoms';

/**
 * Identifies a person in lists, menus and the top bar: their photo when one is available,
 * otherwise their initials — so a broken or missing image never leaves an empty chip.
 */
@Component({
  selector: 'esn-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'img', '[attr.aria-label]': 'name()' },
})
export class AvatarComponent {
  /**
   * The person's display name — accessible label and source of the initials.
   */
  readonly name = input.required<string>();

  /**
   * Optional photo URL; initials show while it is absent or if it fails to load.
   */
  readonly imageUrl = input<string | null>(null);

  protected readonly imageFailed = signal(false);
  protected readonly initials = computed(() => esnInitials(this.name()));

  constructor() {
    effect(() => {
      this.imageUrl();
      this.imageFailed.set(false);
    });
  }
}
